/**
 * Certain external/npm-package components may have interface in here.
 *
 * # Important!
 * Before adding new interfaces here,
 * check whether it is possible to simply import them from the packages
 * themselves with `import { TSomeType } from 'some-package'.
 */ /** */

import { ActionMeta, InputActionMeta } from "react-select"

/**
 * react-select
 */ /** */
export type TReactSelectOption = {
	value: string
	label: string
	isDisabled?: boolean
	/**
	 * In case selected option needs to provide extra information without use of array filter
	 */
	extraProp?: any
	userProp?: string
}
export type TReactSelectSelectedOptions = TReactSelectOption | readonly TReactSelectOption[] | null
export type TUserOption = "userID" | "userEmail" | "userMob" | "userDep" | "userName" | "userValue" | "userField" | "bool"
export type TOnChangeReactSelect = (
	selectedOption: TReactSelectSelectedOptions,
	triggeredAction?: ActionMeta<any>
) => void
export type TOnChangeReactSelectField = (
	selectedOption: TReactSelectSelectedOptions,
	triggeredAction?: ActionMeta<any>,
	field?: TUserOption,
	fieldValue?: string | undefined
) => void
export function isReactSelectOptionArray(
	candidate: TReactSelectSelectedOptions
): candidate is TReactSelectOption[] | readonly TReactSelectOption[] {
	if (!Array.isArray(candidate)) return false

	for (let { label, value } of candidate) {
		if (typeof label != "string" || typeof value != "string") return false
	}

	return true
}

export function isReactSelect(value: any): value is TReactSelectSelectedOptions {
	if (value == null) return false

	return true
}
export function isReactSelectSingleOption(
	candidate: TReactSelectSelectedOptions | string | string[]
): candidate is TReactSelectOption {
	if (candidate == null) return false

	if (Array.isArray(candidate) || typeof candidate != "object") return false

	return true
}
export type TOnInputChangeReactSelect = (newValue: string, actionMeta: InputActionMeta) => void

export type TWatch = {
	(field: string, defaultValue?: string): any
}
export type TRemove = (index?: number | number[] | undefined) => void
export type TMove = (indexA: number, indexB: number) => void
export type TReset = (
	values?:
		| {
				[x: string]: any
		  }
		| undefined,
	omitResetState?:
		| Partial<{
				errors: boolean
				isDirty: boolean
				isSubmitted: boolean
				touched: boolean
				isValid: boolean
				submitCount: boolean
				dirtyFields: boolean
		  }>
		| undefined
) => void
export type TAppend = (
	value: Partial<Record<string, any>> | Partial<Record<string, any>>[],
	shouldFocus?: boolean | undefined
) => void

export type TsetValue = (
	name: string,
	value: any,
	config?:
		| Partial<{
				shouldValidate: boolean
				shouldDirty: boolean
		  }>
		| undefined
) => void
